import React, { PureComponent } from 'react';
import DateMask from "../../../../Common/Components/Mask/DateMask.jsx"
import MontoMask from "../../../../Common/Components/Mask/MontoMask.jsx"

class Resumen extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        let component = null;
        let importePesos = null;
        let importeUss = null;
        let sdoAntImpaPesos = 0;
        let sdoAntImpaUss = 0;
        const { data } = this.props;
        const { resumen } = this.props;
        if (resumen) {
            component = resumen.map((item, index) => {
                sdoAntImpaPesos += (item.CobranzaMonedaId == 1 ? item.Importe : 0.00);
                sdoAntImpaUss += (item.CobranzaMonedaId == 2 ? item.Importe : 0.00);
                importePesos = item.CobranzaMonedaId == 1 ? (item.Importe.toFixed(2) *-1) : "0.00";
                importeUss = item.CobranzaMonedaId == 2 ? (item.Importe.toFixed(2) * -1) : "0.00";
                return (

                    <div className="row no-margin" >
                        <div className="col-xs-3 text-left">
                            <label className="label-primary">{item.FechaCreacion} </label>
                        </div>
                        <div className="col-xs-5 text-left">
                            <label className="label-primary">Pago</label>
                        </div>
                        <div className="col-xs-2 text-right">
                            <MontoMask monto={importePesos} moneda="" class="label-primary" />
                        </div>
                        <div className="col-xs-2 text-right">
                            <MontoMask monto={importeUss} moneda="" class="label-primary" />
                        </div>
                    </div >
                    //}
                )
            })

        }

        let sdoAntPesos = data.SaldoCierrePesos - sdoAntImpaPesos;
        let sdoAntUsd = data.SaldoCierreUss - sdoAntImpaUss;

        return (
            <div>
                <div className="row no-margin box header gris">
                    <div className="col-xs-3 text-left">
                        <label className="label-primary">Fecha</label>
                    </div>
                    <div className="col-xs-5 text-left">
                        <label className="label-primary">Concepto</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <label className="label-primary">$</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <label className="label-primary">U$S</label>
                    </div>
                </div>
                <div className="row box header no-margin colorSR">
                    {/*generar un map para iterar sobre los elementos que tiene el resumen de la cuenta*/}
                    <div className="col-xs-3 text-left">
                        <label className="label-secondary"><DateMask fecha={data.FechaCierreAnterior} /></label>
                    </div>
                    <div className="col-xs-5 text-left">
                        <label className="label-secondary">Saldo al Cierre</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={data.SaldoCierrePesos.toFixed(2)} moneda="" class="label-primary" />
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={data.SaldoCierreUss.toFixed(2)} moneda="" class="label-primary" />
                    </div>
                    {/*fin iteracion*/}
                    {component}
                    <div className="col-xs-12">
                        <hr className="hr-resumenes" />
                    </div>
                    <div className="col-xs-3"></div>
                    <div className="col-xs-5 text-left">
                        <label className="label-primary">Saldo Anterior Impago</label>
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={sdoAntPesos.toFixed(2)} moneda="" class="label-primary" />
                    </div>
                    <div className="col-xs-2 text-right">
                        <MontoMask monto={sdoAntUsd.toFixed(2)} moneda="" class="label-primary" />
                    </div>
                </div>
            </div>
        );
    }
}

export default Resumen;